import React from "react";
import { motion } from "framer-motion";
import { PROJECT } from "../lib/site";

export const ProjectTeaser = () => (
  <section id="project" data-testid="project-section" className="py-24 md:py-32 relative overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(212,175,55,0.07),transparent_60%)] pointer-events-none" />
    <div className="max-w-[1100px] mx-auto px-6 md:px-12 text-center relative">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
      >
        <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-gold border border-gold/40 px-4 py-2">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-60" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-gold" />
          </span>
          {PROJECT.status}
        </span>

        <h2 className="font-serif font-light text-4xl sm:text-6xl lg:text-7xl tracking-tighter mt-8 leading-[0.95]">
          {PROJECT.title}
        </h2>

        <p className="text-base lg:text-lg font-light text-[#B8B8B8] leading-relaxed max-w-2xl mx-auto mt-8">
          {PROJECT.text}
        </p>

        <div className="flex items-center justify-center gap-4 mt-10">
          <a
            href="#newsletter"
            data-testid="project-notify-btn"
            className="bg-gold text-black font-medium px-8 py-4 hover:bg-gold-light transition-colors duration-300 text-sm tracking-wide"
          >
            Être prévenu·e en premier
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);
